import { React } from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import "../ChangeDOC/ChangeDOC.css";
import { saveAs } from 'file-saver';
import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import ddd from "../../Document/templ.docx";

const ChangeDOC = () => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [relocations, setRelocations] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');

  const [firstItem, setFirstItem] = useState({
    relocation_id: "",
    date_of_conversion: "",
  })

  const handleRelocationChange = (event) => {
    const selectedRelocation = relocations.find(rel => rel.relocation_id === Number(event.target.value));
    setSelectedDate(selectedRelocation?.date_of_conversion || '');

    const newRelocationId = event.target.value;
    setFirstItem(prevState => ({
      ...prevState,
      relocation_id: newRelocationId
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };



  const loadFile = (url) => {
    return fetch(url).then((response) => response.arrayBuffer());
  };

  const generateDocument = async () => {
    try {
      const content = await loadFile(ddd);
      const zip = new PizZip(content);

      const doc = new Docxtemplater(zip, {
        paragraphLoop: true,
        linebreaks: true,
      });

      // Define dynamic data
      const data = {
        name: 'John Doe',
        date: '2024-08-02',
        // Add other dynamic data here
      };

      // Replace placeholders with data
      doc.setData(data);

      try {
        // Render the document
        doc.render();
      } catch (error) {
        console.error('Error rendering document:', error);
        throw error;
      }

      // Generate the document as a blob
      const blob = doc.getZip().generate({ type: 'blob' });

      // Save the document
      saveAs(blob, 'output.docx');
    } catch (error) {
      console.error('Error generating document:', error);
    }
  };


  function getDOC() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}userget/convertedLead`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setRelocations(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }

  }



  useEffect(() => {
    getDOC();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const storedToken = JSON.parse(localStorage.getItem("token"));

    try {
      const response = await axios.post(
        `${baseAPI}userpost/updateDOC`,
        firstItem,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      alert('updated successfully');
      setSelectedDate("");      
      setFirstItem({
        relocation_id: "",
        date_of_conversion: "",
      });
      getDOC();

    } catch (error) {
      console.error('Error saving data:', error);
    }
  }

  return (
    <div className="d-flex flex-row app lead-count-data">
      <div
        className="container-fluid"
        style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
      >
        <table>
          <tr>
            <td><span>Relocation ID: </span>
              <select id="relocation-select" onChange={handleRelocationChange}>
                <option value="">--Select--</option>
                {relocations.map(rel => (
                  <option key={rel.relocation_id} value={rel.relocation_id}>
                    {rel.relocation_id}
                  </option>
                ))}
              </select>
            </td>
            <td><span>Date of conversion: </span>
              <input
                id="date-input"
                type="text"
                value={selectedDate}
                disabled
              />
            </td>

            <td><span>New Date of conversion: </span>
              <input
                id="date_of_conversion"
                name="date_of_conversion"
                type="date"
                value={firstItem.date_of_conversion}
                onChange={handleChange}
              />
            </td>

            <td>
              <button
                type="submit"
                className="btn btn-primary"
                onClick={handleSubmit}
              >
                Update
              </button>
              {/* <div>
                <button onClick={generateDocument}>Generate Document</button>
              </div> */}
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default ChangeDOC;
